<style scoped>
  .el-tab-sty {
      padding-left: 15px;
      border-radius: 6px 6px 0 0;
  } 
.bank-card { 
  border:1px solid #f1f1f1;
  height: 100px;
  border-radius: 6px;
}
.enclosure {
  height: 250px;
}
.enclosure .left {
  width: 57px;
  height: 82px;
  border: 1px solid #f1f1f1; 
  float: left;

}
  .enclosure .left  img{
        margin: 20px auto;
    }
 .enclosure .center{
  width: 120px;
  height: 82px;
  border: 1px solid #f1f1f1;
  margin-left: 55px;
  float: left; 
}
  .enclosure .center  img{
        margin: 8px auto;
    }
  .enclosure .right{
  width: 120px;
  height: 82px;
  border: 1px solid #f1f1f1;
  margin-left: 55px;
  float: left; 
} 
  .enclosure .right  img{
        margin: 8px auto;
    }

/deep/ .el-drawer.rtl{
    overflow: scroll;
}
.text-red {
  color: red;
}
</style>
<template>
  <div class="content">
  <div style="background-color: #f9f9f9;height: 50px;text-align: left;padding-left:15px;margin-bottom: 15px;">
     <p class="fl">审批时间：{{ApprovalTime}}        审批结果：</p>
     <p class="ml20 fl w25f" v-show="sh == 'true'">待审批</p>
     <p class="ml20 fl w25f" v-show="sh == '平台审批中'">平台审批中</p>
     <p class="ml20 fl w25f" v-show="sh == '平台审批通过' || sh == '平台审批通过'">平台审批通过</p>
     <p class="ml20 text-red fl w25f" v-show="sh == '平台已驳回'">平台已驳回</p>
  <el-button size="small" class="fr mr15 mt10" type="info" @click="addStaffApprovalHist">审批记录</el-button>  
  </div>
  <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>基本信息</b></div>
      <el-row :gutter="20">  
        <el-col :span="7"><div class="search-area-div1">姓名：{{getStaffBasicInfoList.staffName}}</div> </el-col> 
         <el-col :span="5"><div class="search-area-div1">性别：{{getStaffBasicInfoList.sex == 'M'?"男":"女"}}  </div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">民族：{{getStaffBasicInfoList.nation}}</div> </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7"><div class="search-area-div1">手机号：{{getStaffBasicInfoList.mobileNo}}</div> </el-col>
        <el-col :span="5"><div class="search-area-div1">身份证：{{getStaffBasicInfoList.idCode}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div1">户口性质：{{getStaffBasicInfoList.familyRegisterType == 1?"农业户口":"非农业户口"}}</div> </el-col> 
      </el-row> 
      <el-row :gutter="20">
        <el-col :span="20"><div class="search-area-div1 w100f t-left">户口所在地：{{getStaffBasicInfoList.familyRegisterVenue}}{{getStaffBasicInfoList.familyRegisterAddress}}</div> </el-col> 
      </el-row> 
    </div>
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>社金信息</b></div>
    <div class="t-left">基本工资：{{getStaffBasicInfoList.salary}}</div>
    <p class="t-left"><b>社保</b></p>
      <el-row :gutter="20">
        <el-col :span="7"><div class="search-area-div1">原参保地：{{getStaffBasicInfoList.originalInsLocationName}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div1">目前是否停保：{{getStaffBasicInfoList.isEndInsurance == 'Y'?"是":"否"}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">预计停保时间：{{getStaffBasicInfoList.expectEndInsurance}}</div> </el-col> 
      </el-row>
      <el-row :gutter="20">
      <el-col :span="7"><div class="search-area-div1">期待参保地：{{getStaffBasicInfoList.expectInsLocationName}}</div> </el-col>
      <el-col :span="5"><div class="search-area-div1">期待参保时间：{{getStaffBasicInfoList.expectCalPeroid}}</div> </el-col>
      <el-col :span="5"><div class="search-area-div1">是否该省新参：{{getStaffBasicInfoList.isNewInsured == 'Y'?"是":"否"}}</div> </el-col>
      </el-row> 
      <p class="t-left"><b>公积金</b></p>
      <el-row :gutter="20">
        <el-col :span="7"><div class="search-area-div1">是否参保：{{getStaffBasicInfoList.isPayFund == 'Y'?"是":"否"}}</div> </el-col>  
        <el-col :span="5"><div class="search-area-div1">是否最低标准参保：{{getStaffBasicInfoList.isLowestFundStandard == 'Y'?"是":"否"}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">参保基数：{{getStaffBasicInfoList.fundErBase}}</div> </el-col> 
      </el-row>
    </div>
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>工资账户</b></div>    
      <div class="bank-card w25f">
                <img class="img-sty-check fl ml10 mt10" width="42" height="42" src="../../assets/images/zgyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国银行'">
                <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zggsyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国工商银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgnyyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国农业银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgjsyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国建设银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/jtyh.png" v-show="getStaffBasicInfoList.salaryBank =='交通银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgyzcx.png" v-show="getStaffBasicInfoList.salaryBank =='中国邮政储蓄'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zxyh.png" v-show="getStaffBasicInfoList.salaryBank =='中信银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zggdyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国光大银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgmsyh.png" v-show="getStaffBasicInfoList.salaryBank =='华夏银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgyh.png" v-show="getStaffBasicInfoList.salaryBank =='中国民生银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/gfyh.png" v-show="getStaffBasicInfoList.salaryBank =='广发银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zsyh.png" v-show="getStaffBasicInfoList.salaryBank =='招商银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/xyyh.png" v-show="getStaffBasicInfoList.salaryBank =='兴业银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/payh.png" v-show="getStaffBasicInfoList.salaryBank =='平安银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/pfyh.png" v-show="getStaffBasicInfoList.salaryBank =='浦发银行'">       
                <div class="fl mt10 ml10 w35f t-left"><span>{{getStaffBasicInfoList.salaryBank}}</span> <br><span>{{getStaffBasicInfoList.salaryBankCode}}</span> <br><span>{{getStaffBasicInfoList.salaryBankAccount}}</span></div>
      </div> 
    </div>
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>自由用工信息</b></div>  
      <el-row :gutter="20">
        <el-col :span="7"><div class="search-area-div1">是否参与自由用工：{{getStaffBasicInfoList.achievementBank != null ?"是":"否"}}</div> </el-col>   
      </el-row> 
      <p class="t-left"><b>账户信息</b></p>
      <div class="bank-card w25f">
                <img class="img-sty-check fl ml10 mt10" width="42" height="42" src="../../assets/images/zgyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国银行'">
                <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zggsyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国工商银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgnyyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国农业银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgjsyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国建设银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/jtyh.png" v-show="getStaffBasicInfoList.achievementBank =='交通银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgyzcx.png" v-show="getStaffBasicInfoList.achievementBank =='中国邮政储蓄'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zxyh.png" v-show="getStaffBasicInfoList.achievementBank =='中信银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zggdyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国光大银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgmsyh.png" v-show="getStaffBasicInfoList.achievementBank =='华夏银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zgyh.png" v-show="getStaffBasicInfoList.achievementBank =='中国民生银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/gfyh.png" v-show="getStaffBasicInfoList.achievementBank =='广发银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/zsyh.png" v-show="getStaffBasicInfoList.achievementBank =='招商银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/xyyh.png" v-show="getStaffBasicInfoList.achievementBank =='兴业银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/payh.png" v-show="getStaffBasicInfoList.achievementBank =='平安银行'">
              <img class="img-sty-check fl  ml10 mt10" width="42" height="42" src="../../assets/images/pfyh.png" v-show="getStaffBasicInfoList.achievementBank =='浦发银行'">       
                <div class="fl mt10 ml10 w35f t-left"><span>{{getStaffBasicInfoList.achievementBank}}</span> <br><span>{{getStaffBasicInfoList.achievementBankCode}}</span> <br><span>{{getStaffBasicInfoList.achievementBankAccount}}</span></div>
      </div> 
    </div>
    <div class="search-area h120 mb15">
    <div class="w100f t-left mb15"><b>附件</b></div>
      <div class="enclosure">
          <div class="left">
            <el-image 
            style="width: 59px; height: 84px" v-if="getStaffBasicInfoList.registerPicture != null"
            :src="getStaffBasicInfoList.registerPicture.path" 
            :preview-src-list="srcList">
          </el-image>
          <!-- <img width="59" height="84" style="margin: 0;" :src="getStaffBasicInfoList.registerPicture.path" v-if="getStaffBasicInfoList.registerPicture != null"> -->
          <img width="40" src="../../assets/images/personal.png" v-else>
          </div> 
          <div class="center">
          <el-image 
            style="width: 122px; height: 84px"  :src="getStaffBasicInfoList.idFrontPictContent.path" v-if="getStaffBasicInfoList.idFrontPictContent != null"
            :preview-src-list="srcList">
          </el-image>
          <!-- <img width="122" height="84" style="margin: 0;" :src="getStaffBasicInfoList.idFrontPictContent.path" v-if="getStaffBasicInfoList.idFrontPictContent != null"> -->
          <img width="100" src="../../assets/images/id-z.png" v-else>
          </div>
          <div class="right">
          <el-image 
            style="width: 122px; height: 84px"  :src="getStaffBasicInfoList.idBackPictContent.path" v-if="getStaffBasicInfoList.idBackPictContent != null"
            :preview-src-list="srcList">
          </el-image>
          <!-- <img width="122" height="84" style="margin: 0;" :src="getStaffBasicInfoList.idBackPictContent.path" v-if="getStaffBasicInfoList.idBackPictContent != null"> -->
          <img width="100" src="../../assets/images/id-f.png" v-else>
          </div>
      </div>
    </div>
    <div style="height: 1150px;">
    <div class="search-area mb15 w45f fl h180">
    <div class="w100f t-left mb15"><b>组织信息</b>（初始备案企业）      </div>
      <el-row :gutter="20">  
        <el-col :span="20 "><div class="search-area-div1">企业：{{getStaffBasicInfoList.tenantName}}</div> </el-col>  
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20"><div class="search-area-div1">组织：{{getStaffBasicInfoList.organisationName}}</div> </el-col> 
      </el-row> 
      <el-row :gutter="20">
        <el-col :span="20"><div class="search-area-div1">岗位：{{getStaffBasicInfoList.positionNames}}</div> </el-col> 
      </el-row> 
    </div>
    <div class="search-area mb15 w45f fr h180">
    <div class="w100f t-left mb15"><b>邀请人信息</b></div>
      <el-row :gutter="20">  
        <el-col :span="20"><div class="search-area-div1">姓名：{{getStaffBasicInfoList.inviterName}}</div> </el-col>  
      </el-row>
      <el-row :gutter="20">
        <el-col :span="20"><div class="search-area-div1">企业：{{getStaffBasicInfoList.tenantName}}</div> </el-col> 
      </el-row> 
      <el-row :gutter="20">
        <el-col :span="20"><div class="search-area-div1">组织：{{getStaffBasicInfoList.inviterOrganisationName}}</div> </el-col> 
      </el-row> 
      <el-row :gutter="20">
        <el-col :span="20"><div class="search-area-div1">岗位：{{getStaffBasicInfoList.inviterPositionNames}}</div> </el-col> 
      </el-row> 
    </div>  
        <div v-if="sh=='true'">
        <el-button size="medium" class="fr" type="info" @click="add()">审批</el-button> 
        <el-button size="medium" class="fr mr15" type="info" @click="dialogFormVisible1=true">驳回</el-button>  
        </div>
        
    </div>

    


     <el-dialog title="通过-补充入职信息" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="140px" :label-position="right" class="demo-ruleForm">
          <!-- <div style="background-color: #f1f1f1;height: 40px;line-height: 40px;text-align: left;padding-left:15px;">已选择数量：  3</div><br> -->
           <el-form-item label="签约/参保公司:">
          <el-select v-model="ruleForm.insuredCompanyGuid" placeholder="请选择" class=" w100f">
            <el-option
              v-for="item in insuredCompanys" 
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同性质:">
          <el-select v-model="ruleForm.contractNature" placeholder="请选择" class=" w100f">
            <el-option
              v-for="item in contractNatures" 
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item> 
        <el-form-item label="签约时长:" class="t-left">
          <el-radio v-model="ruleForm.duration" label="12">1年</el-radio>
          <el-radio v-model="ruleForm.duration" label="24">2年</el-radio>
          <el-radio v-model="ruleForm.duration" label="36">3年</el-radio>
        </el-form-item>
        <el-form-item label="合同日期:">
          <el-date-picker
            v-model="timeList"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="代缴公司:">
          <el-select v-model="ruleForm.withheldCompanyGuid" placeholder="请选择" class=" w100f">
            <el-option
              v-for="item in withheldCompanys" 
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代征公司:">
          <el-select v-model="ruleForm.levyCompanyGuid" placeholder="请选择" class=" w100f">
            <el-option
              v-for="item in levyCompanys" 
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审批意见:">
           <el-input v-model="approvalSuggest" class="ipt-sty w100f" placeholder="请输入审批意见"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
         <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
         <el-button  size="medium" type="info" @click="submitForm()" v-loading.fullscreen.lock="fullscreenLoading">确定</el-button> 
      </div>
    </el-dialog>


    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible1" width="550px" title="填写驳回理由">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm"> 
        <el-form-item label="驳回理由:">
          <el-input type="textarea" v-model="approvalSuggest"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
         <el-button plain size="medium" @click="dialogFormVisible1 = false">取消</el-button>
         <el-button  size="medium" type="info" @click="inviteeApproval()">确定</el-button> 
      </div>
    </el-dialog>
    <el-drawer
      title="审批记录"
      :visible.sync="drawer"
      :with-header="true">
      <el-timeline :reverse="reverse">
          <el-timeline-item v-for="(activity, index) in getStaffApprovalHistList" :key="index" class="t-left">
            <p>审批时间：{{activity.operateTime}}</p>
            <p>审批结果：{{activity.approvalState}}</p> 
            <p class="text-red" v-if="activity.approvalState =='驳回'">驳回原因：{{activity.approvalSuggest}}</p>
            <p v-else>审批建议：{{activity.approvalSuggest}}</p>
            <p v-if="activity.approvalState !='' && activity.approvalState !=null">审批人：{{activity.operater}}&nbsp{{activity.mobileNo}}</p>
            <p v-else>申请人：{{activity.operater}}&nbsp{{activity.mobileNo}}</p>
          </el-timeline-item>
        </el-timeline>
    </el-drawer>
  </div>
</template>

<script> 
  export default {  
    data() {
      return {
        textTitle:'',
        drawer: false,
        reverse:false,
        activities: [{
          content: '支持使用图标',
          timestamp: '2018-04-12 20:46',
          size: 'large',
          type: 'primary',
          icon: 'el-icon-more'
        }],
        srcList:[],
        right:'',
        dialogVisible: false,
        dialogFormVisible:false,
        dialogFormVisible1:false,
        getStaffBasicInfoList:'' , 
        sh:'',
        insuredCompanys:[],
         contractNatures:[{
          value:'1',
          label:'劳动合同'
        },{
          value:'2',
          label:'劳务合同'
        },{
            value:'3',
          label:'灵工合同'
        }],
        withheldCompanys:[],
        levyCompanys:[],
        ruleForm: {
          staffInfo:'',
          insuredCompanyGuid:'',
          insuredCompanyName:'',
          contractNature: '',
          startTime: '',
          duration: '12',
          endTime: '',
          withheldCompanyGuid:'',
          withheldCompanyName:'',
          levyCompanyGuid:'',
          levyCompanyName:'',
          memo:''
        },
        approvalSuggest:'',
        getStaffApprovalHistList:'',
        ApprovalTime:'',
        bizState:'',
        itemsList:'',
        timeList:[], 
        timeListS:[],
        fullscreenLoading:false,
      };
    },
    created(){
      this.sh = this.$route.query.sh;
      console.log(this.sh);
    // 列表
    this.getData(); 
    this.getStaffApprovalHist();
    this.getTenantDataGet();
    this.getWithheldCompanys();
    this.getLevyCompanys();
  },
  // beforeRouteLeave(to, from, next) {
  //   //跳转到搜索页面时，search为搜索页面名称
  //   if (to.name == '/entryApproval/detail') {
  //     to.meta.isBack = true;
  //   }

  //   next();
  // },
    methods: { 
      getTenantDataGet() {
              let self = this; 
              self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`,{ pageIndex: 1, pageSize: -1 }).then(res=>{ 
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                          self.insuredCompanys = res.data.data.records;
                     }else {
                      self.$message.error(res.data.msg);
                     } 
              }) 
      },
      getWithheldCompanys() {
              let self = this; 
              self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`,{ pageIndex: 1, pageSize: -1 }).then(res=>{ 
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                          self.withheldCompanys = res.data.data.records;
                     }else {
                      self.$message.error(res.data.msg);
                     } 
              }) 
      },
      getLevyCompanys() {
              let self = this; 
              self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`,{ pageIndex: 1, pageSize: -1 }).then(res=>{ 
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                          self.levyCompanys = res.data.data.records;
                     }else {
                      self.$message.error(res.data.msg);
                     } 
              }) 
      },
      getData() {
              let self = this; 
              self.srcList = [];
              self.api.get(`/${serverConfig.msPersonnelService}/staff/data/get-staff-basic-info?guid=`+this.$route.query.guid).then(res=>{ 
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                      console.log(res.data);
                          self.getStaffBasicInfoList = res.data.data; 
                          self.getStaffBasicInfoList.positionNames  = self.getStaffBasicInfoList.positionNames[0];
                          self.getStaffBasicInfoList.inviterPositionNames  = self.getStaffBasicInfoList.inviterPositionNames[0];
                          self.getStaffBasicInfoList.idFrontPictContent = JSON.parse(res.data.data.idFrontPictContent); 
                          self.getStaffBasicInfoList.idBackPictContent = JSON.parse(res.data.data.idBackPictContent);
                          self.getStaffBasicInfoList.registerPicture = JSON.parse(res.data.data.registerPicture);
                          self.srcList.push(self.getStaffBasicInfoList.idFrontPictContent.path,self.getStaffBasicInfoList.idBackPictContent.path,self.getStaffBasicInfoList.registerPicture.path);
                     }else {
                      self.$message.error(res.msg);
                     } 
              }) 
      },
      addStaffApprovalHist(){
              let self = this; 
              self.drawer = true; 
              self.getStaffApprovalHist();
      },
      getStaffApprovalHist(){
              let self = this;  
              self.api.get(`/${serverConfig.msPersonnelService}/staff/data/get-staff-approval-hist?staffGuid=`+this.$route.query.guid).then(res=>{ 
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                      console.log(res.data);
                          self.getStaffApprovalHistList = res.data.data;
                          self.getStaffApprovalHistList.forEach(function(i){
                                  i.operateTime = self.$moment(i.operateTime).format('YYYY-MM-DD HH:mm:ss');
                          }) 
                          if(self.getStaffApprovalHistList[0].operateTime != 'Invalid date'){
                                self.ApprovalTime = self.$moment(self.getStaffApprovalHistList[0].operateTime).format('YYYY-MM-DD HH:mm:ss');
                                self.bizState = self.getStaffApprovalHistList[0].approvalState;
                          }else{ 
                                self.ApprovalTime = '';
                                self.bizState = '';
                          }
                          
                          // console.log(self.bizState );
                     }else {
                      self.$message.error(res.msg);
                     } 
              }) 
      },
      add(){
        let self = this;
        self.timeList = [];
        self.ruleForm.staffInfo = ''; 
        self.ruleForm.insuredCompanyGuid = '';
        self.ruleForm.insuredCompanyName = '';
        self.ruleForm.contractNature = '';
        self.ruleForm.startTime = '';
        self.ruleForm.duration = '12';
        self.ruleForm.endTime = '';
        self.ruleForm.withheldCompanyGuid = '';
        self.ruleForm.withheldCompanyName = '';
        self.ruleForm.levyCompanyGuid = '';
        self.ruleForm.levyCompanyName = '';
        self.ruleForm.memo = '';
        self.itemsList = '';
        let items = '"'+self.getStaffBasicInfoList.guid+'":"'+self.getStaffBasicInfoList.staffName+'",'
        console.log(items);
        if(self.itemsList == ''){
              self.itemsList = items //JSON.stringify(items).replace("{","").replace("}","");
        }else{
              self.itemsList = self.itemsList  + items //+','+ JSON.stringify(items).replace("{","").replace("}","");
        }
        self.ruleForm.staffInfo = JSON.parse('{'+self.itemsList.substring(0,self.itemsList.length-1)+'}');
        self.dialogFormVisible = true
      }, 
       submitForm() {
        let self = this;  
      //   if(self.approvalSuggest == null || self.approvalSuggest == ''){ 
      //   self.$message.error("请输入审批意见！");
      //   return
      // }   
      if(self.ruleForm.insuredCompanyGuid == null || self.ruleForm.insuredCompanyGuid == ''){
              // self.$message.error("请选择签约/参保公司！");
              // return
      }else{
              self.insuredCompanys.forEach(function(i){
                    if(self.ruleForm.insuredCompanyGuid == i.guid){
                            self.ruleForm.insuredCompanyName = i.tenantName
                    }
              })
      }
      if(self.ruleForm.contractNature == null || self.ruleForm.contractNature == ''){
              // self.$message.error("请选择合同性质！");
              // return
      }
      if(self.timeList == null || self.timeList == ''){
              // self.$message.error("请选择合同起始日期！");
              // return
      }
      if(self.timeList && Array.isArray(self.timeList) && self.timeList.length > 0 && self.timeList[0] && self.timeList[1]){
          self.ruleForm.startTime = self.$moment(self.timeList[0]).format('YYYY-MM-DD HH:mm:ss');
          self.ruleForm.endTime = self.$moment(self.timeList[1]).format('YYYY-MM-DD 23:59:59');
        }else{
          self.ruleForm.startTime = '';
          self.ruleForm.endTime = '';
        }
      if(self.ruleForm.withheldCompanyGuid == null || self.ruleForm.withheldCompanyGuid == ''){
              // self.$message.error("请选择代缴公司！");
              // return
      }else{
              self.withheldCompanys.forEach(function(j){
                    if(self.ruleForm.withheldCompanyGuid == j.guid){
                            self.ruleForm.withheldCompanyName = j.tenantName
                    }
              })
      }
      if(self.ruleForm.levyCompanyGuid == null || self.ruleForm.levyCompanyGuid == ''){
              // self.$message.error("请选择代征公司！");
              // return
      }else{
              self.levyCompanys.forEach(function(i){
                    if(self.ruleForm.levyCompanyGuid == i.guid){
                            self.ruleForm.levyCompanyName = i.tenantName
                    }
              })
      }
      
      self.$confirm('信息未填写完整，确定提交吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          right: true
        }).then(() => {
              let promise = {
                    'tenantGuid':self.$store.state.guid,
                    'approvalSuggest':self.approvalSuggest,
                    'laborContract':self.ruleForm
              }
              console.log(promise);
              self.fullscreenLoading = true;
              // return
              self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/finish-approval`,promise).then(res=>{
                console.log('123',res.data);
                self.fullscreenLoading = false;
                     if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                            self.dialogFormVisible = false;
                            self.$message.success('审批成功');
                            self.$router.push({
                              path: '/entryApproval',
                              query:{
                                productGuid:this.$route.query.productGuid,
                              }
                            }); 
                     }else {
                            self.$message.error(res.data.msg);
                     } 
              })  
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消审批'
          });
        }); 
        
      },
      inviteeApproval() {
      var self = this;    
      if(self.approvalSuggest == null || self.approvalSuggest == ''){ 
        self.$message.error("请输入驳回理由！");
        return
      }   
      self.api.post(`/${serverConfig.msPersonnelService}/staff/data/approval-rejection?`+`staffGuid=` + self.$route.query.guid +`&approvalSuggest=`+self.approvalSuggest+`&tenantGuid=`+self.$store.getters.getTenantGuid).then(function (resp) { 
        console.log(resp);
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success('驳回成功');
             self.$router.push({
                path: '/entryApproval',
                query:{
                  productGuid:this.$route.query.productGuid,
                }
              }); 
        }else{
            self.$message.error(resp.data.msg);
        }
      });
    },



    },
  };
</script> 